module.exports = __webpack_public_path__ + "static/media/chat.15714f5a.png";